import { Icon } from 'src/components/Icon';
import styles from './FileListUpsellMessage.module.scss';
import { UpgradeButton } from 'src/components/UpgradeButton';

export const FileListUpsellMessage = () => {
  return (
    <div className={styles.root}>
      <Icon type="documentsFolder" size={172} />

      <p className={styles.caption}>
        Unlock the full power of Ninja Editor! Upgrade to a paid subscription
        and supercharge your coding and writing.
      </p>

      <UpgradeButton
        dataGTM="file-list-upgrade"
        title="Upgrade now"
        className={styles.upgradeButton}
      />
    </div>
  );
};
